export function modalVideo() {

    const modalVideoBtn = document.querySelectorAll('.js-initModalVideo');
    const modalVideoWrapper = document.querySelector('.js-modalVideo');

    modalVideoBtn.forEach( item => {
        item.addEventListener('click', e => {
            let width = window.innerWidth > 560 ? 560 : window.innerWidth;

            let frame = document.createElement('iframe');
            frame.setAttribute('width', width);
            frame.setAttribute('height', '315');
            frame.setAttribute('src', 'https://www.youtube.com/embed/' + item.dataset.youtube);
            frame.setAttribute('frameborder', '0');
            frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            frame.setAttribute('allowfullscreen', '');

            modalVideoWrapper.innerHTML = '';
            modalVideoWrapper.appendChild(frame);
        });
    });
}